import React, {Component} from 'react'

class Select extends Component {
	constructor(props){
		super(props)
		this.state = {
			selected:  0  
		}
	}
	render(){
		const { placeholder, options, onChange, selected, _id ,mobileSelectPlaceholder} = this.props 
		const curr = options.find((item)=>( item.id === selected ))
		return (
			<div className="select">
				<select name="" id="" onChange={onChange} data-id={ _id}>
					{
						mobileSelectPlaceholder !== false ? <option value="0">{placeholder}</option> : ''
					}
					
					{
						options && options ? options.map((option)=>(
							<option key={option.id} value={option.id}>{option.name}</option>
						)): ''
					}
				</select>
				<div className="curr">{ selected !== 0 ? curr.name : placeholder }</div>
			</div>
		)
	}

}
export default Select


// WEBPACK FOOTER //
// ./src/Components/Select/index.js